module.exports = __webpack_public_path__ + "img/business-plan.d54d19cc.svg";